import { HTTP } from '@/http-common';
import { defineStore } from 'pinia';

export const useFawryStore = defineStore('fawry', {
    state: () => ({
        plans: []
    }),
    getters: {
        getFawryPlans: (state) => state.plans
    },
    actions: {
        async fetchFawryPlans() {
           return new Promise((resolve, reject) => {
            HTTP.get('/fawrypay/plans').then((response) => {
                this.plans = response.data;
                resolve(response.data);
            }).catch((error) => {
                console.error('Error fetching Fawery plans:', error);
                reject(error);
            });
           });
        },
        /**
         * Initialize Fawery payment gateway
         * @param userId
         * @param planId
         * @return {Promise<string>} - The URL to redirect the user to Fawery payment gateway
         */
        async getFawryPaymentUrl(userId, planId) {
              return new Promise((resolve, reject) => {
                HTTP.post('/fawrypay/init', {
                    userId: userId,
                    planId: planId
                }).then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    console.error('Error fetching Fawery payment URL:', error);
                    reject(error);
                });
              });
        },
        /**
         * Verify Fawry payment status
         * @param paymentId
         * @return {Promise<object>} - The payment status object
         */
        async verifyFawryPaymentStatus(merchantRefNumber) {
            return new Promise((resolve, reject) => {
                HTTP.post(`/fawrypay/status/`, { merchantRefNumber: merchantRefNumber }).then((response) => {
                   
                    resolve(response);
                }).catch((error) => {
                    console.error('Error verifying Fawry payment status:', error);
                    reject(error);
                });
            });
        },
    },
});
